import { create } from "zustand";

/** Everything the invite modal needs to know about what is being shared. */
export type ReferralInviteTarget =
  | { context: "locked"; cityUrl: string; cityName: string }
  | { context: "unlocked"; cityUrl: string };

interface ReferralInviteStore {
  open: boolean;
  target: ReferralInviteTarget;
  openModal: (target: ReferralInviteTarget) => void;
  closeModal: () => void;
}

/**
 * Drives the single invite modal mounted in AppLayout. Every trigger - the
 * account nav, the city buttons, the homepage CTA, onboarding - opens this one
 * instance, so its heading ids only ever exist once in the document.
 */
export const useReferralInviteStore = create<ReferralInviteStore>((set) => ({
  open: false,
  target: { context: "unlocked", cityUrl: "" },
  openModal: (target) => set({ open: true, target }),
  closeModal: () => set({ open: false }),
}));
